import axios from 'axios'

import {
  CompassAPIMultiSeriesChartData,
  getMultipleLineChartProps,
} from '../utils/compass'
import type { BaseContext } from './'

const MERGE_AND_ACQUISITIONS_CHARTS_PATH = '/api/charts/merge-and-acquisitions'

export namespace MergeAndAcquisitions {
  export namespace HistoricalUpside {
    const CONTEXT_ID = 'equity:merge_and_acquisitions:historical_upside'

    export const __typelist: {
      config: ChartConfig
      data: ChartData
      context: ContextType
    } = {} as any

    export type ContextType = BaseContext<
      typeof CONTEXT_ID,
      ChartConfig,
      ChartData
    >

    export interface ChartConfig {
      title?: string
      fusionName: string
      context: typeof CONTEXT_ID
    }

    export type ChartData = CompassAPIMultiSeriesChartData

    const getChartData = async (config: ChartConfig) =>
      axios({
        url: MERGE_AND_ACQUISITIONS_CHARTS_PATH + '/fusions/historical-upside',
        method: 'GET',
        params: { fusion_name: config.fusionName },
      }).then((response) => response.data)

    const getChartProps = (
      config: ChartConfig,
      data: CompassAPIMultiSeriesChartData
    ) =>
      getMultipleLineChartProps(
        Context,
        {
          chartTitle: 'Upside histórico',
          convertToPercentages: Array(data.data.length).fill(true),
        },
        { type: Array(data.data.length).fill('spline') }
      )(config, data)

    export const Context: ContextType = {
      id: CONTEXT_ID,
      getChartId: (config) => `${config.context}:${config.fusionName}`,
      getChartData,
      getChartProps,
    }
  }
}
